import { useLoaderState } from 'hooks/useLoader';

export const LoaderRedux = ({ children }: { children: React.ReactNode }) => {
  const { isLoading } = useLoaderState();

  return (
    <div>
      {isLoading && <h1>Loading...</h1>}
      {children}
    </div>
  );
};
